module.exports = __webpack_public_path__ + "img/_icon-click-n-ship.4aff0f30.svg";